export default __webpack_public_path__ + "static/media/ic_text-bold.a8396530.svg";